/**
 * @example
 *  - ['department']
 *  - ['department', 'list', <filters>]
 *  - ['department', 'detail', <id>]
 */
const DashboardQueryKeys = {
  company: () => ['company-stats'],
  order: (date: string) => ['order-stats', date]
};

export default DashboardQueryKeys;
